<template>
  <div id="app">
   
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
      let type =  navigator.systemLanguage || navigator.language;
      console.log(type)

      if(type.indexOf("zh")==0){
        if(type=='zh-TW'){
          this.$i18n.locale = 'tw'
        }else{
          this.$i18n.locale = 'cn'  //汉语
        }

      }else if(type.indexOf("en")==0) 
      {
        this.$i18n.locale = 'en'  //英语

      }else if(type.indexOf('fr')==0){  

        this.$i18n.locale = 'fr'  //法语

      }else if(type.indexOf('de')==0){  

        this.$i18n.locale = 'de'  //德语

      }else if(type.indexOf('es')==0){

        this.$i18n.locale = 'es'  //西班牙语

      }else if(type.indexOf('pt')==0){

        this.$i18n.locale = 'pt'  //葡萄牙语

      }else if(type.indexOf('ar')==0){

        this.$i18n.locale = 'ar'  //阿拉伯语

      }else if(type.indexOf('hi')==0){

        this.$i18n.locale = 'hi'  //印地语

      }else if(type.indexOf('ko')==0){

        this.$i18n.locale = 'ko'  //韩语 

      }else if(type.indexOf('ru')==0){

        this.$i18n.locale = 'ru'  //俄罗斯语

      } else{
        this.$i18n.locale = 'en'  //英语
      }
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


</style>
